export const PUSH_GTM_EVENT_START = 'PUSH_GTM_EVENT_START';